export default {
    errorCode: {
        COMMON_ERROR: '不明错误',
        ADMIN_FAILCREATE: '创建失败',
        ADMIN_FAILUPDATE: '更新失败',
        ADMIN_FAILDELETE: '删除失败',
        ADMIN_FAIL: '失败',
        ADMIN_TOPSLAVE: 'ADMIN_TOPSLAVE',
        ADMIN_ATLEASTHAVEONEAUTH: 'ADMIN_ATLEASTHAVEONEAUTH',
        ADMIN_LOSINGDATA: '资料缺失',
        ADMIN_NOAUTHORITY: 'ADMIN_NOAUTHORITY',
        ADMIN_SYSTEMERROR: '系统错误',
        ADMIN_DELETECONFIRMFAIL: '删除失败',
        ADMIN_AUTH_ACCOUNTVERIFICATIONFAILD: '帐号验证失败',
        ADMIN_AUTH_LOGINAGAIN: '请再次登入',
        ADMIN_AUTH_PLSLOGIN: '请先登入',
        ADMIN_AUTH_ILLEGALPARENT: 'ADMIN_AUTH_ILLEGALPARENT',
        ADMIN_AUTH_HAVINGCHILD: 'ADMIN_AUTH_HAVINGCHILD',
        ADMIN_AUTH_AUTHNOTEXISTS: '权限不存在',
        ADMIN_AUTH_USERNOTEXIST: '使用者不存在',
        ADMIN_AUTH_ACCOUNTDISABLE: '帐号无权限',
        ADMIN_AUTH_TOKENEXPIRED: '登入权限过期',
        ADMIN_LOGIN_USERNOTEXISTS: '使用者不存在',
        ADMIN_LOGIN_EXPIRE: '过期',
        ADMIN_LOGIN_ANDROIDAPKKEYHASHMISMATCH: 'ADMIN_LOGIN_ANDROIDAPKKEYHASHMISMATCH',
        ADMIN_MERCHANT_RPIDEXISTS: '参数错误',
        ADMIN_MERCHANT_EMAILEXISTS: 'email 不存在',
        ADMIN_MAILBINDPASSKEY_EXPIRE: '信件过期',
        ADMIN_MAILBINDPASSKEY_INVALIDEMAIL: 'email 错误',
        ADMIN_APPS_APPNOTEXISTS: 'App 不存在',
        ADMIN_APPS_APPLICATIONIDNOTEXISTS: 'App id 不存在',
        ADMIN_APPS_EMAILEXISTS: 'email 不存在',
        ADMIN_APPS_NOTENABLED: 'App 无法使用',
        ADMIN_APPUSER_IMPORTUSERERROR: 'App user 汇入错误',
        ADMIN_ROLE_EXISTRELATEUSER: 'ADMIN_ROLE_EXISTRELATEUSER',
        ACCEPTED: '参数错误',
        ACCEPTED_IF: '参数错误',
        ACTIVE_URL: '参数错误',
        AFTER: '参数错误',
        AFTER_OR_EQUAL: '参数错误',
        ALPHA: '参数错误',
        ALPHA_DASH: '参数错误',
        ALPHA_NUM: '参数错误',
        ARRAY: '参数错误',
        BEFORE: '参数错误',
        BEFORE_OR_EQUAL: '参数错误',
        BETWEEN_NUMERIC: '参数错误',
        BETWEEN_FILE: '参数错误',
        BETWEEN_STRING: '参数错误',
        BETWEEN_ARRAY: '参数错误',
        BOOLEAN: '参数错误',
        CONFIRMED: '参数错误',
        CURRENT_PASSWORD: '参数错误',
        DATE: '日期错误',
        DATE_EQUALS: '参数错误',
        DATE_FORMAT: '日期错误',
        DECLINED: '参数错误',
        DECLINED_IF: '参数错误',
        DIFFERENT: '参数错误',
        DIGITS: '参数错误',
        DIGITS_BETWEEN: '参数错误',
        DIMENSIONS: '参数错误',
        DISTINCT: '参数错误',
        EMAIL: '参数错误',
        ENDS_WITH: '参数错误',
        ENUM: '参数错误',
        EXISTS: '参数错误',
        FILE: '参数错误',
        FILLED: '参数错误',
        GT_NUMERIC: '参数错误',
        GT_FILE: '参数错误',
        GT_STRING: '参数错误',
        GT_ARRAY: '参数错误',
        GTE_NUMERIC: '参数错误',
        GTE_FILE: '参数错误',
        GTE_STRING: '参数错误',
        GTE_ARRAY: '参数错误',
        IMAGE: '参数错误',
        IN: '参数错误',
        IN_ARRAY: '参数错误',
        INTEGER: '参数错误',
        IP: 'IP错误',
        IPV4: 'IP错误',
        IPV6: 'IP错误',
        JSON: '参数错误',
        LT_NUMERIC: '参数错误',
        LT_FILE: '参数错误',
        LT_STRING: '参数错误',
        LT_ARRAY: '参数错误',
        LTE_NUMERIC: '参数错误',
        LTE_FILE: '参数错误',
        LTE_STRING: '参数错误',
        LTE_ARRAY: '参数错误',
        MAC_ADDRESS: '参数错误',
        MAX_NUMERIC: '参数错误',
        MAX_FILE: '参数错误',
        MAX_STRING: '参数错误',
        MAX_ARRAY: '参数错误',
        MIMES: '参数错误',
        MIMETYPES: '参数错误',
        MIN_NUMERIC: '参数错误',
        MIN_FILE: '参数错误',
        MIN_STRING: '参数错误',
        MIN_ARRAY: '参数错误',
        MULTIPLE_OF: '参数错误',
        NOT_IN: '参数错误',
        NOT_REGEX: '参数错误',
        NUMERIC: '参数错误',
        PASSWORD: '参数错误',
        PRESENT: '参数错误',
        PROHIBITED: '参数错误',
        PROHIBITED_IF: '参数错误',
        PROHIBITED_UNLESS: '参数错误',
        PROHIBITS: '参数错误',
        REGEX: '参数错误',
        REQUIRED: '参数错误',
        REQUIRED_ARRAY_KEYS: '参数错误',
        REQUIRED_IF: '参数错误',
        REQUIRED_UNLESS: '参数错误',
        REQUIRED_WITH: '参数错误',
        REQUIRED_WITH_ALL: '参数错误',
        REQUIRED_WITHOUT: '参数错误',
        REQUIRED_WITHOUT_ALL: '参数错误',
        SAME: '参数错误',
        SIZE_NUMERIC: '参数错误',
        SIZE_FILE: '参数错误',
        SIZE_STRING: '参数错误',
        SIZE_ARRAY: '参数错误',
        STARTS_WITH: '参数错误',
        STRING: '参数错误',
        TIMEZONE: '参数错误',
        UNIQUE: '参数错误',
        UPLOADED: '参数错误',
        URL: '参数错误',
        UUID: '参数错误',
    },
}
